export default __webpack_public_path__ + "static/media/insight.ff5b1f7c.svg";